import React, { useState } from 'react'
import { Breadcrumb, Card, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InboxOutlined } from '@ant-design/icons'
import { faCogs, faHome, faVideo } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { settingAlert, settingResponse, settings, settingsRefresh } from '../../../states/settings';
import { Input, Form, Button as AntButton, Modal, Upload } from 'antd';
import AlertToast from '../../../components/AlertToast';
import { updateSettings } from '../../../services/apiCalls';
import { createHowItWorkModal, howItWork } from '../../../states/howItWork';
import HowItWorkModal from './Modal';
import Table from './Table';
import { dummyRequest } from '../../../services/utilities';
import { createFaqModal, faq } from '../../../states/faqs';

const Faqs = () => {
  const data = useRecoilValueLoadable(settings)
  const dataList = useRecoilValueLoadable(faq)
  const [viewModal, setViewModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [video, setFile] = useState()
  const [showAlert, setShowAlert] = useRecoilState(settingAlert);
  const [response, setResponse] = useRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(settingsRefresh)
  const setCreateModal = useSetRecoilState(createFaqModal);
  const settingData = data.state === "hasValue" ? data.contents : {}
  const howItWorkData = dataList.state === "hasValue" && dataList.contents ? dataList.contents : []
  const [form] = Form.useForm()

  const onFinishUpdate = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('video', video);
    fd.append('id', val.id);
    try {
      const res = await updateSettings({ data: fd, type: "how_it_works" })
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setViewModal(false)
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
    setFile()
  }

  // const onFinishUpdate = async (val) => {
  //   const date = new Date()
  //   setLoading(true)
  //   const res = await updateSettings({ data: val, type: "how_it_works" })
  //   if (res.status) {
  //     setResponse({ message: res.message, title: "success" })
  //     setShowAlert(true)
  //     setRefresh(date.toTimeString())
  //     setViewModal(false)
  //   } else {
  //     setResponse({ message: res.message || res, title: "failed" })
  //     setShowAlert(true)
  //   }
  //   setLoading(false)
  // }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="How it work" />
      <HowItWorkModal />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya pay</Breadcrumb.Item>
            <Breadcrumb.Item active>FAQs</Breadcrumb.Item>
          </Breadcrumb>
          <h4>FAQs Page</h4>
        </div>
      </div>
      <div className="table-settings mb-4">
        {/* <Button variant="secondary" className="text-white me-3" onClick={() => { setViewModal(true) }}>
          Update video<FontAwesomeIcon icon={faVideo} className="d-none d-sm-inline ms-1" />
        </Button> */}
        <Button variant="success" className="text-white me-3" onClick={() => setCreateModal(true)}>
          Create New FAQs <FontAwesomeIcon icon={faCogs} className="d-none d-sm-inline ms-1" />
        </Button>
      </div>
      <Card border="light" className="bg-white shadow-sm my-4">
        <Card.Body>
          <h5 className="mb-4 text-primary">FAQs</h5>
          <Table data={howItWorkData} />
        </Card.Body>
      </Card>
      {/* How it work video start */}
      <Modal
        title="Update FAQs"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinishUpdate} layout="vertical">
          <Form.Item label="How it work vidoe url" name="id" initialValue={settingData.id}>
            <Input />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1} rules={[{ required: true }]}>
              <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/* How it work video end */}
    </div>
  )
}

export default Faqs
